
import React, {Component} from 'react';
import {connect} from 'react-redux'
import {InputGroup,Form,FormControl,FormGroup} from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import Select from 'react-select';
import AssetStore from 'stores/AssetStore'
const NotificationSystem = require('react-notification-system')

class AssetVehicleDocFixingPage extends Component {

  constructor(...args){
    super(...args)

    this.state = {        
        data:[]
    }
  }

  componentDidMount() {
    AssetStore.loadReportWorkByVehicle(this.props.vehicleId,(result)=>{
        this.setState({data:result.data})
    })
  }

  componentWillReceiveProps(newProps) {
     
  }


  render() {
      return(
          <div style={{marginBottom:'10px'}}>
              Hello
          </div>
      )
  }
}  

AssetVehicleDocFixingPage.defaultProps = {
   vehicleId:''
}

export default AssetVehicleDocFixingPage = connect(
  (state) => ({messages: {}}),null,null,{withRef:true}
)(AssetVehicleDocFixingPage);



// WEBPACK FOOTER //
// ./src/view/tyre/report-asset-vehicle-page/AssetVehicleDocFixingPage.js